import { DataTestIdProps } from "@custom-types/ui-types";
import { Box, BoxProps, SvgIcon } from "@mui/material";
import { blue } from "@flat-ui";
import { getSvgColoredIconCss } from "@utils/ui-utils";
import { ElementType } from "react";

interface Props extends DataTestIdProps {
  /**
   * Defines a component to show as an icon.
   * E.g.
   * import { ReactComponent as FeedbackIcon } from "@assets/icons/Feedback.svg";
   * component={FeedbackIcon}
   */
  component: ElementType;

  /**
   * Triggered when the users clicks on the icon.
   */
  onClick?: BoxProps["onClick"];

  /**
   * Optional size in pixels for the icon.
   * Default "24px".
   */
  iconSize?: string;
}

/**
 * Renders an icon that can be clicked, similar to SphereIconButton but without the button.
 * It is just an icon that changes color when hovered.
 */
export function FaroClickableIcon({
  component,
  onClick,
  iconSize = "24px",
  dataTestId,
}: Props): JSX.Element {
  return (
    <Box
      component="div"
      sx={{
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        "&:hover": {
          ...getSvgColoredIconCss(blue[500]),
        },
      }}
      onClick={onClick}
      data-testid={dataTestId}
    >
      <SvgIcon
        inheritViewBox
        component={component}
        sx={{
          height: iconSize,
          width: iconSize,
        }}
      />
    </Box>
  );
}
